/**
 * Departamentos y municipios de Honduras
 */
export const DEPARTAMENTOS = [
  {
    nombre: "Atlántida",
    municipios: [
      "La Ceiba", "Tela", "El Porvenir", "Esparta", "Jutiapa",
      "La Masica", "San Francisco", "Arizona",
    ],
  },
  {
    nombre: "Choluteca",
    municipios: [
      "Choluteca", "El Corpus", "El Triunfo", "Marcovia", "Namasigüe",
      "Orocuina", "Pespire", "San Marcos de Colón", "San Antonio de Flores",
      "Apacilagua", "Concepción de María", "Duyure", "Morolica",
      "San Isidro", "San José", "Santa Ana de Yusguare",
    ],
  },
  {
    nombre: "Colón",
    municipios: [
      "Trujillo", "Tocoa", "Sabá", "Sonaguera", "Bonito Oriental",
      "Balfate", "Iriona", "Limón", "Santa Fe", "Santa Rosa de Aguán",
    ],
  },
  {
    nombre: "Comayagua",
    municipios: [
      "Comayagua", "Siguatepeque", "Taulabé", "La Trinidad", "San Jerónimo",
      "Ajuterique", "El Rosario", "La Libertad", "Lejamaní", "Meámbar",
      "Minas de Oro", "San José de Comayagua", "San Luis", "Villa de San Antonio",
      "Esquías", "Humuya", "Lamaní", "Ojos de Agua",
    ],
  },
  {
    nombre: "Copán",
    municipios: [
      "Santa Rosa de Copán", "Copán Ruinas", "La Entrada", "Nueva Arcadia",
      "Santa Rita", "Trinidad de Copán", "Cabañas", "Concepción", "Corquín",
      "Cucuyagua", "Dolores", "Dulce Nombre", "El Paraíso", "Florida",
      "La Jigua", "La Unión", "San Agustín", "San Antonio", "San Jerónimo",
      "San José", "San Juan de Opoa", "San Nicolás", "San Pedro", "Veracruz",
    ],
  },
  {
    nombre: "Cortés",
    municipios: [
      "San Pedro Sula", "Choloma", "La Lima", "Villanueva", "Puerto Cortés",
      "Omoa", "Potrerillos", "San Manuel", "Pimienta", "Santa Cruz de Yojoa",
      "San Francisco de Yojoa", "San Antonio de Cortés", "El Progreso",
    ],
  },
  {
    nombre: "El Paraíso",
    municipios: [
      "Danlí", "Yuscarán", "El Paraíso", "Teupasenti", "Morocelí",
      "Jacaleapa", "San Antonio de Flores", "Texiguat", "Alauca",
      "Güinope", "Liure", "Oropolí", "Potrerillos", "San Lucas",
      "San Matías", "Vado Ancho", "Yauyupe",
    ],
  },
  {
    nombre: "Francisco Morazán",
    municipios: [
      "Tegucigalpa / Distrito Central", "Comayagüela", "Amarateca",
      "Valle de Ángeles", "Santa Lucía", "San Juancito", "Talanga",
      "Cedros", "Curarén", "El Porvenir", "Güaimaca", "La Libertad",
      "La Venta", "Lepaterique", "Maraita", "Marale", "Nueva Armenia",
      "Ojojona", "Orica", "Reitoca", "Sabanagrande", "San Antonio de Oriente",
      "San Buenaventura", "San Ignacio", "San Juan de Flores",
      "San Miguelito", "Santa Ana", "Tatumbla", "Vallecillo", "Villa de San Francisco",
    ],
  },
  {
    nombre: "Gracias a Dios",
    municipios: [
      "Puerto Lempira", "Ahuas", "Juan Francisco Bulnes",
      "Villeda Morales", "Wampusirpe", "Brus Laguna",
    ],
  },
  {
    nombre: "Intibucá",
    municipios: [
      "La Esperanza", "Intibucá", "Jesús de Otoro", "Camasca",
      "Colomoncagua", "Concepción", "Dolores", "Magdalena", "Masaguara",
      "San Antonio", "San Isidro", "San Juan", "San Marcos de la Sierra",
      "San Miguelito", "Santa Lucía", "Yamaranguila",
      "San Francisco de Opalaca",
    ],
  },
  {
    nombre: "Islas de la Bahía",
    municipios: [
      "Roatán", "Guanaja", "Utila", "José Santos Guardiola",
    ],
  },
  {
    nombre: "La Paz",
    municipios: [
      "La Paz", "Marcala", "Aguanqueterique", "Cane", "Chinacla",
      "Guajiquiro", "Lauterique", "Mercedes de Oriente", "Opatoro",
      "San Antonio del Norte", "San José", "San Juan", "San Pedro de Tutule",
      "Santiago de Puringla", "Yarula",
    ],
  },
  {
    nombre: "Lempira",
    municipios: [
      "Gracias", "Lepaera", "Erandique", "La Unión", "San Marcos de Caiquín",
      "Belén", "Candelaria", "Cololaca", "Gualcince", "Guarita",
      "La Campa", "La Iguala", "Las Flores", "La Virtud", "Mapulaca",
      "Piraera", "San Andrés", "San Francisco", "San Juan Guarita",
      "San Manuel Colohete", "San Rafael", "San Sebastián",
      "Santa Cruz", "Talgua", "Tambla", "Tomalá", "Valladolid", "Virginia",
    ],
  },
  {
    nombre: "Ocotepeque",
    municipios: [
      "Nueva Ocotepeque", "Belén Gualcho", "Concepción", "Dolores Merendón",
      "Fraternidad", "La Encarnación", "La Labor", "Lucerna", "Mercedes",
      "San Fernando", "San Francisco del Valle", "San Jorge", "San Marcos",
      "Santa Fe", "Sensenti", "Sinuapa",
    ],
  },
  {
    nombre: "Olancho",
    municipios: [
      "Juticalpa", "Catacamas", "Campamento", "San Esteban", "Gualaco",
      "Dulce Nombre de Culmí", "Salama", "La Unión", "Manto", "Yocon",
      "Concordia", "El Rosario", "Esquipulas del Norte", "Guaraní",
      "Guata", "Lepaguare", "Mangulile", "San Francisco de Becerra",
      "San Francisco de la Paz", "Santa María del Real", "Silca",
    ],
  },
  {
    nombre: "Santa Bárbara",
    municipios: [
      "Santa Bárbara", "San Pedro Zacapa", "San Luis", "Quimistán",
      "Las Vegas", "Trinidad", "Arada", "Atima", "Azacualpa",
      "Ceguaca", "Chinda", "Concepción del Norte", "Concepción del Sur",
      "Gualala", "Ilama", "Macuelizo", "Naranjito", "Nicapa",
      "Nueva Frontera", "Petoa", "Protección", "San Francisco de Ojuera",
      "San José de Colinas", "San Marcos", "San Nicolás", "Santa Rita",
    ],
  },
  {
    nombre: "Valle",
    municipios: [
      "Nacaome", "San Lorenzo", "Amapala", "Alianza", "Aramecina",
      "Caridad", "Goascorán", "Langue", "San Francisco de Coray",
    ],
  },
  {
    nombre: "Yoro",
    municipios: [
      "Yoro", "El Progreso", "Olanchito", "El Negrito", "Morazán",
      "Jocón", "Santa Rita", "Sulaco", "Victoria", "Yorito",
    ],
  },
];

/** Mapa rápido: departamento → lista de municipios */
export const MUNICIPIOS_POR_DEPTO = Object.fromEntries(
  DEPARTAMENTOS.map((d) => [d.nombre, d.municipios])
);
